import { createUseStyles } from 'react-jss'

import { RedDarken16, TextSlateGreyDarken12 } from '@/const/colors'
import { FontCaption } from '@/const/fontStyles'

export default createUseStyles(
  {
    title: {
      ...FontCaption,
      color: TextSlateGreyDarken12,
      marginBottom: 4,
    },
    errorMessage: {
      ...FontCaption,
      color: RedDarken16,
      marginTop: 4,
    },
  },
  { name: 'InputPhoneControlled' }
)
